import moment from 'moment'

export const getFormattedDate = (
  date,
  schema,
) => moment(date).format(schema)

export const getFormattedUtcDate = (
  date,
  schema,
) =>
  // Parse the date as UTC and format it
  moment.utc(date).format(schema)

export const getFormattedAddedDateFromNow = (
  date,
  count,
  schema,
) => moment(date).add(count, 'd').format(schema)

export const getFormattedSubtractedDateFromNow = (
  date,
  count,
  schema,
) => moment(date).subtract(count, 'd').format(schema)

export const getFullDateFromISO = (
  date,
  schema = 'DD/MM/YY hh:mm:ss A',
) => moment(date).format(schema)

export const getYear = (date) => moment(date).year()

export const getMonth = (date) => moment(date).month() + 1
export const getFormattedStringToIsoDate = (date) =>
  moment(date).utc().format(FORMAT_DATE_TYPE.isoDate)

export const getStartOfYear = (
  date = new Date(),
  schema,
) => moment(date).startOf('year').format(schema)

export const getStartOfMonth = (
  date = new Date(),
  schema,
) => moment(date).startOf('month').format(schema)

export const getStartOfPreviousMonth = (
  date = new Date(),
  schema,
) => moment(date).subtract(1, 'month').startOf('month').format(schema)

export const getLastDayOfMonth = (
  date,
  schema
) => moment(date).endOf('month').format(schema)

export const getMonthBefore = (
  date = new Date(),
  format = 'YYYY-MM',
) => {
  const momentDate = moment(date).subtract(1, 'month')

  if (format) {
    return momentDate.format(format)
  }
  return momentDate.toDate()
}

export const getEndOfDayDate = (
  date = new Date(),
  format,
) => {
  if (format) {
    return moment(date).endOf('day').format(format)
  }
  return moment(date).endOf('day').format()
}

export const getUnixTimestamp = (date) => moment(date).unix()
